<template>
  <button class="btn btn-outline-secondary" @click="goBack()"><font-awesome-icon icon="chevron-left" /> Zurück</button>

  <div v-if="!loading && (vertrag == null || vertrag.id == 0)" class="alert alert-danger mt-5">Ungültige Vorlage ID: {{ vertragid }}</div>

  <div v-else-if="!loading">
    <!-- TITEL -->
    <div class="d-flex justify-content-between align-items-center mb-2">
      <h1 class="m-0">{{ vertrag.titel }}</h1>

      <router-link :to="{ name: 'EditVertrag', query: { vertragid: vertragid } }" class="btn"><font-awesome-icon icon="pen" /></router-link>
    </div>

    <h5 class="text-muted fst-italic mb-0">{{ vertrag.titelEN }}</h5>

    <div v-if="vertragErrorMsg != ''" class="alert alert-danger">
      {{ vertragErrorMsg }}
    </div>

    <!-- BESCHREIBUNG -->
    <section id="vertrag-details-beschreibung">
      <div v-if="vertrag.ddate != null" class="text-end mb-1">
        <span class="text-secondary">Der Vertrag wird am {{ dateToDateConverter(vertrag.ddate) }} automatisch gelöscht.</span>
      </div>
      <div class="row mx-0 mb-3">
        <div class="col-4 ps-0 pe-1 d-flex">
          <div class="bg-white rounded shadow p-3 flex-fill">
            <div class="row mb-2">
              <div class="col">
                <div class="row">
                  <div class="col fw-bold">Vertragsbeginn:</div>
                  <div v-if="vertrag.vertragsBeginn != null" class="col">
                    {{ dateToDateConverter(vertrag.vertragsBeginn) }}
                  </div>
                </div>
              </div>

              <div class="col">
                <div class="row">
                  <div class="col fw-bold">Vertragsende:</div>
                  <div v-if="vertrag.vertragsEnde != null" class="col">
                    {{ dateToDateConverter(vertrag.vertragsEnde) }}
                  </div>
                </div>
              </div>
            </div>

            <hr class="my-3" />

            <div class="row mb-2">
              <div class="col-4 fw-bold">Typ</div>
              <div class="col">
                {{ vertrag.type == 0 ? 'Neuvertrag' : 'Nachtrag' }}
              </div>
            </div>

            <div class="row mb-2">
              <div class="col-4 fw-bold">Standort</div>
              <div class="col">
                {{ vertrag.standort }}
              </div>
            </div>

            <div class="row mb-2">
              <div class="col-4 fw-bold">Tarifgebiet</div>
              <div class="col">
                {{ vertrag.tarifgebiet }}
              </div>
            </div>

            <div class="row mb-2">
              <div class="col-4 fw-bold">HRBP Standard</div>
              <div class="col">
                {{ vertrag.hrbpStandard }}
              </div>
            </div>

            <div class="row mb-2">
              <div class="col-4 fw-bold">AU Vorlage</div>
              <div class="col">
                {{ vertrag.auVorlage }}
              </div>
            </div>

            <hr class="my-3" />

            <div class="row mb-2">
              <div class="col-4 fw-bold">Dokument ID</div>
              <div class="col">
                {{ vertrag.docId }}
              </div>
            </div>

            <div class="row mb-2">
              <div class="col-4 fw-bold">Action ID</div>
              <div class="col">
                {{ vertrag.actionId }}
              </div>
            </div>
          </div>
        </div>

        <div class="col-4 px-1 d-flex">
          <div class="bg-white rounded shadow p-3 flex-fill">
            <h4>Vertragspartner 1</h4>
            <div class="row mb-2">
              <div class="col-4 fw-bold">Unternehmen</div>
              <div class="col">
                {{ vertrag.vertragspartei1?.unternehmen }}
              </div>
            </div>

            <div class="row mb-2">
              <div class="col-4 fw-bold">Unternehmenzusatz</div>
              <div class="col">
                {{ vertrag.vertragspartei1?.unternehmenzusatz }}
              </div>
            </div>

            <div class="row mb-2">
              <div class="col-4 fw-bold">Anrede</div>
              <div class="col">{{ vertrag.vertragspartei1?.anrede }}</div>
            </div>

            <div class="row mb-2">
              <div class="col-4 fw-bold">Name</div>
              <div class="col">{{ vertrag.vertragspartei1?.vorname }} {{ vertrag.vertragspartei1?.name }}</div>
            </div>

            <div class="row mb-2">
              <div class="col-4 fw-bold">Straße</div>
              <div class="col">
                {{ vertrag.vertragspartei1?.strasse }}
              </div>
            </div>

            <div class="row mb-2">
              <div class="col-4 fw-bold">PLZ / Ort</div>
              <div class="col">{{ vertrag.vertragspartei1?.plz }} {{ vertrag.vertragspartei1?.ort }}</div>
            </div>

            <div class="row mb-2">
              <div class="col-4 fw-bold">Land</div>
              <div class="col">
                {{ vertrag.vertragspartei1?.land }}
              </div>
            </div>
          </div>
        </div>

        <div class="col-4 ps-1 pe-0 d-flex">
          <div class="bg-white rounded shadow p-3 flex-fill">
            <h4>Vertragspartner 2</h4>
            <div class="row mb-2">
              <div class="col-4 fw-bold">Unternehmen</div>
              <div class="col">
                {{ vertrag.vertragspartei2?.unternehmen }}
              </div>
            </div>

            <div class="row mb-2">
              <div class="col-4 fw-bold">Unternehmenzusatz</div>
              <div class="col">
                {{ vertrag.vertragspartei2?.unternehmenzusatz }}
              </div>
            </div>

            <div class="row mb-2">
              <div class="col-4 fw-bold">Anrede</div>
              <div class="col">{{ vertrag.vertragspartei2?.anrede }}</div>
            </div>

            <div class="row mb-2">
              <div class="col-4 fw-bold">Name</div>
              <div class="col">{{ vertrag.vertragspartei2?.vorname }} {{ vertrag.vertragspartei2?.name }}</div>
            </div>

            <div class="row mb-2">
              <div class="col-4 fw-bold">Straße</div>
              <div class="col">
                {{ vertrag.vertragspartei2?.strasse }}
              </div>
            </div>

            <div class="row mb-2">
              <div class="col-4 fw-bold">PLZ / Ort</div>
              <div class="col">{{ vertrag.vertragspartei2?.plz }} {{ vertrag.vertragspartei2?.ort }}</div>
            </div>

            <div class="row mb-2">
              <div class="col-4 fw-bold">Land</div>
              <div class="col">
                {{ vertrag.vertragspartei2?.land }}
              </div>
            </div>

            <div class="row">
              <div class="col-4 fw-bold">Personal GUID</div>
              <div class="col">{{ vertrag.personaldatenGuid }}</div>
            </div>
          </div>
        </div>
      </div>

      <div class="row mx-0 mb-5">
        <div class="col-3 ps-0 pe-1 d-flex">
          <div class="bg-white rounded shadow p-3 flex-fill">
            <h4>Unterschrift 1</h4>

            <div class="row mb-2">
              <div class="col-4 fw-bold">Zeichnung</div>
              <div class="col">
                {{ vertrag.zeichnung1 }}
              </div>
            </div>

            <div class="row mb-2">
              <div class="col-4 fw-bold">Unterschrift</div>
              <div class="col">
                {{ vertrag.unterschrift1 }}
              </div>
            </div>

            <div class="row mb-2">
              <div class="col-4 fw-bold">Funktion (DE)</div>
              <div class="col">
                {{ vertrag.funktion1 }}
              </div>
            </div>

            <div class="row">
              <div class="col-4 fw-bold">Funktion (EN)</div>
              <div class="col">
                {{ vertrag.funktion1EN }}
              </div>
            </div>
          </div>
        </div>

        <div class="col-3 px-1 d-flex">
          <div class="bg-white rounded shadow p-3 flex-fill">
            <h4>Unterschrift 2</h4>

            <div class="row mb-2">
              <div class="col-4 fw-bold">Zeichnung</div>
              <div class="col">
                {{ vertrag.zeichnung2 }}
              </div>
            </div>

            <div class="row mb-2">
              <div class="col-4 fw-bold">Unterschrift</div>
              <div class="col">
                {{ vertrag.unterschrift2 }}
              </div>
            </div>

            <div class="row mb-2">
              <div class="col-4 fw-bold">Funktion (DE)</div>
              <div class="col">
                {{ vertrag.funktion2 }}
              </div>
            </div>

            <div class="row">
              <div class="col-4 fw-bold">Funktion (EN)</div>
              <div class="col">
                {{ vertrag.funktion2EN }}
              </div>
            </div>
          </div>
        </div>

        <div class="col-3 px-1 d-flex">
          <div class="bg-white rounded shadow p-3 flex-fill">
            <h4 class="mb-1">Kündigungsfrist</h4>
            <p class="text-muted fw-bold">während der Probezeit</p>

            <p class="fw-bold mb-1">Deutsch:</p>
            <p>{{ vertrag.kfWaerendProbezeit }}</p>

            <p class="fw-bold mb-1">Englisch:</p>
            <p>{{ vertrag.kfWaerendProbezeitEN }}</p>
          </div>
        </div>

        <div class="col-3 ps-1 pe-0 d-flex">
          <div class="bg-white rounded shadow p-3 flex-fill">
            <h4 class="mb-1">Kündigungsfrist</h4>
            <p class="text-muted fw-bold">nach der Probezeit</p>

            <p class="fw-bold mb-1">Deutsch:</p>
            <p>{{ vertrag.kfNachProbezeit }}</p>

            <p class="fw-bold mb-1">Englisch:</p>
            <p>{{ vertrag.kfNachProbezeitEN }}</p>
          </div>
        </div>
      </div>
    </section>

    <!-- TEXTABSCHNITTE -->
    <section class="mb-4" id="vertrag-details-abschnitte">
      <div class="d-flex justify-content-between align-items-center">
        <h3>Abschnitte</h3>
        <!-- <button class="btn btn-primary" @click="generateDocument()"><font-awesome-icon icon="file-download" /> Dokument erstellen</button> -->
        <!-- <DownloadVertragDocumentModal :vertrag="vertrag" :personaldaten="personaldaten" /> -->
        <button type="button" class="btn btn-primary" @click="toggleAbschnitteCollapse()">
          <font-awesome-icon v-if="abschnitteIsCollapsed" icon="magnifying-glass-plus" />
          <font-awesome-icon v-else icon="close" />
        </button>
      </div>

      <div class="" :class="{ collapse: abschnitteIsCollapsed }">
        <div v-if="vertrag.textabschnitte.length > 0" class="mt-3">
          <nav>
            <div class="nav nav-tabs" id="nav-tabs" role="tablist">
              <button
                class="nav-link active"
                id="nav-tab-deutsch"
                data-bs-toggle="tab"
                data-bs-target="#nav-deutsch"
                type="button"
                role="tab"
                aria-controls="nav-deutsch'"
                aria-selected="true"
              >
                Deutsch
              </button>

              <button
                class="nav-link"
                id="nav-tab-english"
                data-bs-toggle="tab"
                data-bs-target="#nav-english"
                type="button"
                role="tab"
                aria-controls="nav-english"
                aria-selected="false"
              >
                Englisch
              </button>
            </div>
          </nav>

          <div class="tab-content py-3" id="nav-content">
            <!-- DEUTSCH -->
            <div class="tab-pane fade show active" id="nav-deutsch" role="tabpanel" aria-labelledby="nav-tab-deutsch" tabindex="0">
              <AbschnittRow
                v-for="abschnitt in vertrag.textabschnitte.filter((a) => a.selected).sort((a: TextAbschnitt, b: TextAbschnitt) => a.position - b.position)"
                :key="abschnitt.id"
                :abschnitt="abschnitt"
                :inputs="vertrag.inputs"
              />
            </div>

            <!-- ENGLISCH -->
            <div class="tab-pane fade" id="nav-english" role="tabpanel" aria-labelledby="nav-tab-english" tabindex="1">
              <AbschnittRowEN
                v-for="abschnitt in vertrag.textabschnitte.filter((a) => a.selected).sort((a: TextAbschnitt, b: TextAbschnitt) => a.position - b.position)"
                :key="abschnitt.id"
                :abschnitt="abschnitt"
                :inputs="vertrag.inputs"
              />
            </div>
          </div>
        </div>
      </div>
    </section>

    <section>
      <div class="d-flex justify-content-between align-items-center">
        <h3>Dokumente</h3>
        <!-- <button class="btn btn-primary" @click="generateDocument()"><font-awesome-icon icon="file-download" /> Dokument erstellen</button> -->
        <!-- <DownloadVertragDocumentModal :vertrag="vertrag" :personaldaten="personaldaten" /> -->
        <button type="button" class="btn btn-primary" @click="toggleDokumenteCollapse()">
          <font-awesome-icon v-if="dokumenteIsCollapsed" icon="magnifying-glass-plus" />
          <font-awesome-icon v-else icon="close" />
        </button>
      </div>

      <div :class="{ collapse: dokumenteIsCollapsed }">
        <LoadingSpinner v-if="dokumenteLoading" text="... Dokumente werden geladen ..." />

        <!-- <div v-else class="d-flex">
          <button class="btn btn-primary" @click="createNewVertragDokument()"><font-awesome-icon icon="plus" /> Dokument erstellen</button>
        </div> -->

        <div class="dropdown">
          <button class="btn btn-primary dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
            <font-awesome-icon icon="plus" /> Dokument erstellen
          </button>

          <ul class="dropdown-menu">
            <li class="dropdown-item" @click="createNewVertragDokument('DE')">Deutsch</li>
            <li class="dropdown-item" @click="createNewVertragDokument('DE_EN')">Deutsch/Englisch</li>
          </ul>
        </div>

        <div v-if="!dokumenteLoading && vertragDokumentErrorMsg != ''" class="alert alert-danger my-2">
          {{ vertragDokumentErrorMsg }}
        </div>

        <div
          v-if="!dokumenteLoading && vertragDokumentErrorMsg == '' && (vertrag.vertragdokumente == null || vertrag.vertragdokumente.length == 0)"
          class="alert alert-info my-2"
        >
          Keine Dokumente vorhanden
        </div>

        <div v-if="!dokumenteLoading && vertrag.vertragdokumente != null && vertrag.vertragdokumente.length > 0" class="mt-3">
          <div class="row mx-1 mb-1">
            <div class="col fw-bold">Titel</div>
            <div class="col-2 fw-bold">Erstellt am</div>
            <div class="col-2 fw-bold">Bearbeitet am</div>
            <div class="col-2 fw-bold"></div>
          </div>

          <VertragDokumentRow
            v-for="dokument in vertrag.vertragdokumente.sort(
              (a: VertragDokument, b: VertragDokument) => new Date(b.mdate).getTime() - new Date(a.mdate).getTime()
            )"
            :key="dokument.id"
            :dokument="dokument"
            :titel="getVertragDokumentVertragTitle(dokument)"
            :qrCodeData="qrCodeData"
            :vertragspartner2Name="vertrag.vertragspartei2?.vorname + ' ' + vertrag.vertragspartei2?.name"
            :vertragspartei="vertrag.vertragspartei1"
          />
        </div>
      </div>
    </section>

    <hr class="my-4" />

    <button class="btn btn-danger" @click="deleteVertragRequest()"><font-awesome-icon icon="trash" /> Vertrag löschen</button>
  </div>

  <ConfirmationAlert ref="confirmationAlertRef" @confirm="deleteVertrag" />

  <LoadingOverlay v-if="loading" text="... Daten werden geladen ..." />
</template>

<script lang="ts" setup>
  //#region Imports
  import { computed, ref, PropType, onMounted } from 'vue';
  import { useStore } from '@/store';
  import { useRouter } from 'vue-router';
  import { useDateConverter } from '@/utils/date_converter';

  import { ActionTypes as VertragActionTypes } from '@/store/modules/Vertraege/actions';
  import { ActionTypes as VariablenActionTypes } from '@/store/modules/Variablen/actions';
  import { ActionTypes as DokumenteActionTypes } from '@/store/modules/Druckvorlagen/actions';
  import { ActionTypes as VorlagenActionTypes } from '@/store/modules/Vorlagen/actions';
  import { ActionTypes as CommonActionTypes } from '@/store/modules/Common/actions';

  import AbschnittRow from '@/components/Vertrag/AbschnittRow.vue';
  import AbschnittRowEN from '@/components/Vertrag/AbschnittRowEN.vue';
  import VertragDokumentRow from '@/components/Vertrag/VertragDokumentRow.vue';
  import ConfirmationAlert from '@/components/ConfirmationAlert.vue';
  import LoadingOverlay from '@/components/LoadingOverlay.vue';
  import LoadingSpinner from '@/components/LoadingSpinner.vue';

  import { Vertrag, TextAbschnitt, VertragDokument } from '@/models/VertragModels';
  //#endregion

  const props = defineProps({
    vertragid: {
      type: String as PropType<string>,
      required: true,
    },

    guid: {
      type: String as PropType<string>,
      default: '',
    },
  });

  const store = useStore();
  const router = useRouter();
  const { dateToDateConverter, dateToReverseShortConverter } = useDateConverter();

  const localLoading = ref(false);
  const loading = computed(
    () =>
      localLoading.value ||
      store.getters.status.getVertraegeLoading ||
      store.getters.status.createVertragLoading ||
      store.getters.status.deleteVertragLoading ||
      store.getters.status.getEinstellungenLoading
  );
  const vertragErrorMsg = computed(() => store.getters.status.vertragErrorMsg);

  const dokumenteLoading = computed(() => store.getters.status.getVertragDokumenteLoading);
  const vertragDokumentErrorMsg = computed(() => store.getters.status.vertragDokumentErrorMsg);

  const vertrag = computed(() => {
    const data = store.getters.vertraege.find((v: Vertrag) => v.id == parseInt(props.vertragid));
    return data ? data : new Vertrag();
  });

  const abschnitteIsCollapsed = ref(true);
  function toggleAbschnitteCollapse() {
    abschnitteIsCollapsed.value = !abschnitteIsCollapsed.value;
  }

  const dokumenteIsCollapsed = ref(false);
  function toggleDokumenteCollapse() {
    dokumenteIsCollapsed.value = !dokumenteIsCollapsed.value;
  }

  function goBack() {
    router.push({ name: 'Vertraege' });

    // if (props.guid != '') {
    //   router.push({ name: 'DetailsPersonaldaten', params: { guid: props.guid } });
    // } else {
    //   router.push({ name: 'Vertraege' });
    // }
  }

  //#region Create Vertrag Dokument
  function replaceVariablesInText(text: string, language: string): string {
    for (let input of vertrag.value.inputs) {
      if (input.variable != null && input.variable.validationType == 'usersignature' && store.getters.authUser?.canSign) {
        const signatureName = store.getters.authUser?.name != '' ? store.getters.authUser?.name : store.getters.authUser?.benutzername || '';
        input.value = signatureName;
      }

      if (input.variable != null && input.variable.type == 'date' && input.variable.validationType == 'today') {
        input.value = new Date().toISOString();
      }

      if (input.value != null && input.value != '') {
        let textKey = input.variable.platzhalter.replace('<<', '&lt;&lt;');
        textKey = textKey.replace('>>', '&gt;&gt;');

        if (input.variable.type.toLowerCase() == 'date') {
          text = text.replaceAll(textKey, dateToDateConverter(input.value));
        } else {
          let inputValue = input.value;

          if (language.toLowerCase() == 'en' && input.valueEN != null && input.valueEN != '') {
            inputValue = input.valueEN;
          }

          text = text.replaceAll(textKey, inputValue);
          text = text.replaceAll(input.variable.platzhalter, inputValue);
        }
      }
    }

    const variableRegex = /&lt;&lt;([^&]+)&gt;&gt;/g;

    let match;
    while ((match = variableRegex.exec(text)) !== null) {
      const span = document.createElement('span');
      span.style.backgroundColor = 'yellow';
      span.textContent = `[[${match[1]}]]`;

      text = text.replace(match[0], span.outerHTML);
    }

    text = text.replaceAll('[[', '&lt;&lt;');
    text = text.replaceAll(']]', '&gt;&gt;');
    // text = text.replaceAll('[[', '<<');
    // text = text.replaceAll(']]', '>>');

    return text;
  }

  function addSubabschnittWithHTMLListCheck(abschnitt: string, subabschnitt: string): string {
    // check if htmlContentString ends with </ol> or </ul> and section begins with <ol> or <ul>
    var endsWithOl = abschnitt?.endsWith('</ol>');
    var beginsWithOl = subabschnitt?.startsWith('<ol>');
    var endsWithUl = abschnitt?.endsWith('</ul>');
    var beginsWithUl = subabschnitt?.startsWith('<ul>');

    if ((endsWithOl && beginsWithOl) || (endsWithUl && beginsWithUl)) {
      // remove last </ol> from htmlContentString
      abschnitt = abschnitt?.substring(0, abschnitt.length - 5)?.trim();

      // add subAbschnitt.textbaustein.text without <ol> at the beginning
      abschnitt += removeTrailingEmptyHTMLTags(subabschnitt?.substring(4)?.trim());
    } else {
      abschnitt += removeTrailingEmptyHTMLTags(subabschnitt?.trim());
    }

    return abschnitt?.trim();
  }

  function removeTrailingEmptyHTMLTags(text: string): string {
    // Entfernt alle leeren <p>, <li>, <h1>-<h6>, <p><br></p> oder <p><br /></p> am Ende
    if (text == null) return '';

    return text.replace(/((<p>(?:<br\s*\/?>)?\s*<\/p>)|(<li>\s*<\/li>)|(<h[1-6]>\s*<\/h[1-6]>))+$/gi, '');
  }

  function generateDocumentContentDE(): string {
    let htmlContentString = '';

    for (var abschnitt of vertrag.value.textabschnitte.filter((a) => a.selected).sort((a: TextAbschnitt, b: TextAbschnitt) => a.position - b.position)) {
      if (abschnitt.textbaustein.titel.length > 0) {
        htmlContentString += '<h1>' + abschnitt.textbaustein.titel?.trim() + '</h1>';
      }

      htmlContentString += removeTrailingEmptyHTMLTags(abschnitt.textbaustein.text?.trim());

      if (abschnitt.abschnitte != null && abschnitt.abschnitte.length > 0) {
        for (var subAbschnitt of abschnitt.abschnitte.filter((a) => a.selected).sort((a: TextAbschnitt, b: TextAbschnitt) => a.position - b.position)) {
          if (subAbschnitt.textbaustein.titel.length > 0) {
            htmlContentString += '<h2>' + subAbschnitt.textbaustein.titel?.trim() + '</h2>';
          }

          htmlContentString = addSubabschnittWithHTMLListCheck(htmlContentString, subAbschnitt.textbaustein.text);
        }
      }
    }

    return replaceVariablesInText(htmlContentString, 'de');
  }

  // function generateDocumentContentEN(): string {
  //   let htmlContentString = '';

  //   for (var abschnitt of vertrag.value.textabschnitte.filter((a) => a.selected).sort((a: TextAbschnitt, b: TextAbschnitt) => a.position - b.position)) {
  //     if (abschnitt.textbaustein.titelEN.length > 0) {
  //       htmlContentString += '<h1>' + abschnitt.textbaustein.titelEN?.trim() + '</h1>';
  //     }

  //     htmlContentString += removeTrailingEmptyHTMLTags(abschnitt.textbaustein.textEN?.trim());

  //     if (abschnitt.abschnitte != null && abschnitt.abschnitte.length > 0) {
  //       for (var subAbschnitt of abschnitt.abschnitte.filter((a) => a.selected).sort((a: TextAbschnitt, b: TextAbschnitt) => a.position - b.position)) {
  //         if (subAbschnitt.textbaustein.titelEN.length > 0) {
  //           htmlContentString += '<h2>' + subAbschnitt.textbaustein.titelEN?.trim() + '</h2>';
  //         }

  //         htmlContentString = addSubabschnittWithHTMLListCheck(htmlContentString, subAbschnitt.textbaustein.textEN);
  //       }
  //     }
  //   }

  //   return replaceVariablesInText(htmlContentString, 'en');
  // }

  function generateDocumentContentDEEN(): string {
    let htmlContentString = '';

    // DE Inhalte
    htmlContentString += '<h4>Deutsche Version</h4>';

    for (var abschnitt of vertrag.value.textabschnitte.filter((a) => a.selected).sort((a: TextAbschnitt, b: TextAbschnitt) => a.position - b.position)) {
      let abschnittContentString = '';

      // Skip Signatur Bausteine, da dieser nur einmal am Ende (im EN Teil) auftauchen soll
      if (abschnitt.textbaustein.isSignaturBaustein) {
        continue;
      }

      abschnittContentString = '';

      // Titel DE / EN
      if (abschnitt.textbaustein.titel.length > 0) {
        abschnittContentString = '<h1>' + abschnitt.textbaustein.titel?.trim() + '</h1>';
      }

      // Text DE, wenn verfügbar
      if (abschnitt.textbaustein.text?.length > 0 || (abschnitt.abschnitte != null && abschnitt.abschnitte.length > 0)) {
        abschnittContentString += removeTrailingEmptyHTMLTags(abschnitt.textbaustein.text?.trim());

        if (abschnitt.abschnitte != null && abschnitt.abschnitte.length > 0) {
          for (var subAbschnitt of abschnitt.abschnitte.filter((a) => a.selected).sort((a: TextAbschnitt, b: TextAbschnitt) => a.position - b.position)) {
            if (subAbschnitt.textbaustein.titel.length > 0) {
              abschnittContentString += '<h2>' + subAbschnitt.textbaustein.titel?.trim() + '</h2>';
            }

            abschnittContentString = addSubabschnittWithHTMLListCheck(abschnittContentString, subAbschnitt.textbaustein.text);
          }
        }

        abschnittContentString = replaceVariablesInText(abschnittContentString, 'de');
      }

      if (abschnittContentString != '') {
        htmlContentString += abschnittContentString;
      }
    }

    // EN Inhalte
    htmlContentString += '<br /><br /><h4>English Version</h4>';

    for (var abschnitt of vertrag.value.textabschnitte.filter((a) => a.selected).sort((a: TextAbschnitt, b: TextAbschnitt) => a.position - b.position)) {
      let abschnittContentString = '';

      // Titel DE / EN
      if (abschnitt.textbaustein.titelEN.length > 0) {
        abschnittContentString = '<h1>' + abschnitt.textbaustein.titelEN?.trim() + '</h1>';
      }

      // Text EN, wenn verfügbar
      if (abschnitt.textbaustein.textEN?.length > 0 || (abschnitt.abschnitte != null && abschnitt.abschnitte.length > 0)) {
        abschnittContentString += removeTrailingEmptyHTMLTags(abschnitt.textbaustein.textEN?.trim());

        if (abschnitt.abschnitte != null && abschnitt.abschnitte.length > 0) {
          for (var subAbschnitt of abschnitt.abschnitte.filter((a) => a.selected).sort((a: TextAbschnitt, b: TextAbschnitt) => a.position - b.position)) {
            if (subAbschnitt.textbaustein.titelEN.length > 0) {
              abschnittContentString += '<h2>' + subAbschnitt.textbaustein.titelEN?.trim() + '</h2>';
            }

            abschnittContentString = addSubabschnittWithHTMLListCheck(abschnittContentString, subAbschnitt.textbaustein.textEN);
          }
        }

        abschnittContentString = replaceVariablesInText(abschnittContentString, 'en');
      }

      if (abschnittContentString != '') {
        htmlContentString += abschnittContentString;
      }
    }

    return htmlContentString;
  }

  function createNewVertragDokument(language: string = 'DE') {
    const data = new VertragDokument();
    data.vertragid = vertrag.value.id;
    data.fileName =
      vertrag.value.titel +
      '_' +
      vertrag.value.vertragspartei2?.name +
      '_' +
      vertrag.value.vertragspartei2?.vorname +
      '_' +
      dateToReverseShortConverter(new Date()) +
      '_' +
      language;

    // if (language == 'EN') {
    //   data.data = generateDocumentContentEN();
    // }

    if (language == 'DE_EN') {
      data.data = generateDocumentContentDEEN();
    } else {
      data.data = generateDocumentContentDE();
    }

    // console.log(data.data);

    store.dispatch(VertragActionTypes.CreateVertragDokument, data);
  }

  function getVertragDokumentVertragTitle(dokument: VertragDokument): string {
    if (dokument.fileName.includes('DE_EN')) {
      let title = vertrag.value.titel.trim();

      if (vertrag.value.titelEN != undefined && vertrag.value.titelEN.trim() != '') {
        title += ' / ' + vertrag.value.titelEN.trim();
      }

      return title;
    } else {
      return vertrag.value.titel.trim();
    }
  }

  const qrCodeData = computed<string>(() => {
    if (
      vertrag.value == undefined ||
      vertrag.value.docId == undefined ||
      vertrag.value.docId == '' ||
      vertrag.value.personaldatenGuid == undefined ||
      vertrag.value.personaldatenGuid == ''
    ) {
      return '';
    }

    let qr = `${vertrag.value.personaldatenGuid}_${vertrag.value.docId}`;

    if (qr != '' && vertrag.value.actionId != undefined && vertrag.value.actionId != '') {
      qr += `_${vertrag.value.actionId}`;
    }

    if (qrCodeTrennzeichen.value != undefined && qrCodeTrennzeichen.value != '' && qrCodeTrennzeichen.value != '_') {
      qr = qr.replaceAll('_', qrCodeTrennzeichen.value);
    }

    return qr;
  });

  const qrCodeTrennzeichen = computed(() => store.getters.qrCodeTrennzeichen);

  async function getQRCodeTrennzeichen() {
    await store.dispatch(CommonActionTypes.GetQRCodeTrennzeichen, undefined);
  }
  //#endregion

  //#region DELETE
  const confirmationAlertRef = ref();

  function deleteVertragRequest() {
    confirmationAlertRef.value?.showAlert('Vertrag löschen', 'Möchten Sie den Vertrag unwiderruflich löschen?', 'danger', '', 'danger', 'text-white');
  }

  function deleteVertrag() {
    store.dispatch(VertragActionTypes.DeleteVertrag, parseInt(props.vertragid)).then(() => {
      if (vertragErrorMsg.value == '') {
        goBack();
      }
    });
  }
  //#endregion

  onMounted(async () => {
    localLoading.value = true;

    await store.dispatch(VertragActionTypes.GetVertragById, parseInt(props.vertragid));

    // Dann alle anderen Aufrufe parallel ausführen
    await Promise.all([
      store.getters.variablen.length == 0 ? store.dispatch(VariablenActionTypes.GetVariablen, undefined) : Promise.resolve(),
      store.getters.vorlagen.length == 0 ? store.dispatch(VorlagenActionTypes.GetVorlagen, undefined) : Promise.resolve(),
      store.dispatch(VertragActionTypes.GetVertragVertragDokumente, parseInt(props.vertragid)),
      store.dispatch(DokumenteActionTypes.GetDruckvorlagen, undefined),
      getQRCodeTrennzeichen(),
    ]);

    localLoading.value = false;
  });
</script>

<style scoped>
  .dropdown-item {
    cursor: pointer;
  }
</style>
